import gql from 'graphql-tag'

export const updateContactsCategory = ({ categoryId, categoryData }) => {
	return {
		mutation: gql`
			mutation updateSingleContactsCategory(
				$category_id: bigint!
				$category_name: String!
				$order: smallint!
				$country_id: bigint!
			) {
				update_contacts_categories_by_pk(
					pk_columns: { id: $category_id }
					_set: {
						category_name: $category_name
						country_id: $country_id
						order: $order
					}
				) {
					id
				}
			}
		`,
		variables: {
			...categoryData,
			category_id: categoryId
		}
	}
}
